import { QR_SERVICE_API_URL } from "./config";

export interface Platform {
  name: string;
  url: string;
  image: string;
}

export const getPlatforms = async (branchId: string): Promise<Platform[]> => {
  const response = await fetch(`${QR_SERVICE_API_URL}/api/v1/platforms/${branchId}`);

  if (!response.ok) {
    throw new Error(`Статус ошибки - ${response.status}`);
  }

  return await response.json();
};
